import React from 'react';
import { withRouter } from 'react-router-dom';

class AnexarComprovanteCorrigida extends React.Component {

    constructor() {

        super();

        this.state = {
            disabled: false,
            centro: "",
            centroId: 0,
            id: "",
            anexo: null,
            filtroAno: "",
            filtroMes: "",
            vecMovPrev: null,
            vecMov: null
        };

        this.changeAnexo = this.changeAnexo.bind(this);
        this.cancelar = this.cancelar.bind(this);
        this.enviar = this.enviar.bind(this);

    }

    changeAnexo(e) {
        e.preventDefault();
        this.setState({ anexo: e.target.files[0] });
    }

    cancelar() {

        let obj = {
            row: {
                id: this.state.id,
                data: []
            },
            filtroAno: this.state.filtroAno,
            filtroMes: this.state.filtroMes,
            vecMovPrev: this.state.vecMovPrev,
            vecMov: this.state.vecMov
        };

        this.props.history.push({
            pathname: "/visualizarmovimentacao",
            state: obj
        });

    }

    enviar() {

        let re = /^.{1,}\.(pdf|xml|jpg|jpeg|png)$/i;

        if (this.state.anexo === null) {

            this.props.errMsgHandler("Por favor, faça o anexo do comprovante de pagamento.");

        } else if (!re.test(this.state.anexo.name)) {

            this.props.errMsgHandler("É permitido somente o anexo de arquivos PDF, XML, JPG e PNG.");

        } else {

            this.setState({ disabled: true });
            this.props.waitMsgHandler("Aguardando");

            let formData = new FormData();
            formData.append('file', this.state.anexo);

            fetch("/api/movimentacao/anexarcomprovantecorreto/" + this.state.id, {
                method: "POST",
                headers: {
                    "Authorization": "Basic " + btoa(localStorage.auth)
                },
                mode: "cors",
                body: formData
            })
            .then(response => response.json())
            .then(responseJson => {

                if (responseJson.msg === "success") {

                    this.props.waitMsgHandler("");
                    this.props.successMsgHandler("Comprovante de Pagamento anexado com sucesso.");

                    let obj = {
                        row: {
                            id: this.state.id,
                            data: []
                        },
                        filtroAno: this.state.filtroAno,
                        filtroMes: this.state.filtroMes,
                        vecMovPrev: this.state.vecMovPrev,
                        vecMov: this.state.vecMov
                    };

                    this.props.history.push({
                        pathname: "/visualizarmovimentacao",
                        state: obj
                    });

                }

            });

        }

    }

    componentDidMount() {

        if (localStorage.roleMovimentacoes !== "escrever"
            && localStorage.roleMovimentacoes !== "corrigir") {

            window.location.href = "/home";

        }

        if (this.props.location.state === undefined) {
            window.location.href = "/movimentacoes";
        }

        let centro = this.props.location.state.centro;
        let centroId = this.props.location.state.centroId;
        let id = this.props.location.state.id;
        let filtroAno = this.props.location.state.filtroAno;
        let filtroMes = this.props.location.state.filtroMes;
        let vecMovPrev = this.props.location.state.vecMovPrev;
        let vecMov = this.props.location.state.vecMov;

        this.setState({ centro: centro });
        this.setState({ centroId: centroId });
        this.setState({ id: id });
        this.setState({ filtroAno: filtroAno });
        this.setState({ filtroMes: filtroMes });
        this.setState({ vecMovPrev: vecMovPrev });
        this.setState({ vecMov: vecMov });

    }

    render() {
        return(
            <div>
                <h1 id="anexar-corr-title">
                    Anexar Comprovante de Pagamento Corrigido
                </h1><br />
                <p id="anexar-corr-centro">
                    <b>Centro: </b> { this.state.centro }
                </p><br /><br />
                <p id="anexar-corr-txt">
                    Selecione o arquivo do Comprovante de Pagamento correto.
                </p><br />
                <input type="file"
                    id="cadmovimentacao-nf-file"
                    onChange={ this.changeAnexo }
                    accept="application/pdf, image/jpeg, image/png, application/xml" />
                <br /><br /><br />
                <button Class="anexar-corr-btn"
                    id="anexar-corr-cancelar-btn"
                    onClick={ this.cancelar }>Cancelar</button>
                <button Class="aprovar-movimentacao-btn"
                    id="anexar-corr-enviar-btn"
                    onClick={ this.enviar }
                    disabled={ this.state.disabled }>Enviar</button>
                <br /><br />
            </div>
        );
    }

}

export default withRouter(AnexarComprovanteCorrigida);

